<template>
  <div data-testid="phone-form">
    <InputText
      v-if="isDisabledPhoneInput"
      :id="phoneForm.disabledPhone._id"
      class="mb"
      :name="phoneForm.disabledPhone._id"
      :data-testid="phoneForm.disabledPhone._id"
      :label="phoneForm.disabledPhone.label"
      :value="formatPhone(user.personalProfile.mobile)"
      disabled
    />
    <PhoneInput
      v-else
      :id="phoneForm.enabledPhone._id"
      v-model="user.personalProfile.mobile"
      class="mb"
      :name="phoneForm.enabledPhone._id"
      :data-testid="phoneForm.enabledPhone._id"
      :label="phoneForm.enabledPhone.label"
      required
    />
    <InputText
      :id="phoneForm.skypeContact._id"
      v-model="user.personalProfile.skypeContact"
      class="mb"
      :name="phoneForm.skypeContact._id"
      :data-testid="phoneForm.skypeContact._id"
      :label="phoneForm.skypeContact.label"
      @input="trimSkypeMaxLength"
    />
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { InputText } from '@warrenbrasil/nebraska-web';
import { formatPhone } from '@/modules/common/helpers/phone';
import { phoneFormProperties } from './helpers';
import { PhoneInput } from '../PhoneInput';

@Component({
  components: { InputText, PhoneInput }
})
export default class PhoneForm extends Vue {
  @Prop({ required: true }) private user!: any;

  private isDisabledPhoneInput = true;
  private phoneForm = phoneFormProperties;
  private formatPhone = formatPhone;

  private created() {
    this.setDisabledPhoneInput();
  }

  private setDisabledPhoneInput(): void {
    this.isDisabledPhoneInput = Boolean(this.user.personalProfile.mobile);
  }

  public trimSkypeMaxLength(inputValue: string) {
    this.user.personalProfile.skypeContact = inputValue.substring(0, 100);
  }
}
</script>
